import {Injectable} from '@angular/core';
import {Http, XHRBackend, RequestOptions, Request, RequestOptionsArgs, Response, Headers} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

// services
import { AuthService } from './auth.service';

@Injectable()
export class HttpService extends Http {
  constructor(
      backend: XHRBackend,
      defaultOptions: RequestOptions,
      private router: Router
    ) {
    super(backend, defaultOptions);
  }

  request(url: string|Request, options?: RequestOptionsArgs): Observable<Response> {
    return super.request(url, options).catch(this.catchErrors());
  }

  catchErrors() {
      return (res: Response) => {
      if (res.status === 401 || res.status === 403) {
        localStorage.removeItem(environment.userKey);
        this.router.navigateByUrl('/auth/login');
      }
      return Observable.throw(res);
    };
  }
}



// WEBPACK FOOTER //
// C:/WORK/ZENN/mcr-contabilidade-fileshare/Application/ApplicationUI/src/app/shared/services/http.service.ts